export enum ApplicationConstantsEnum {
  APPLICATION_PDF = "application/pdf",
  CHARACTER_EMPTY = "",
  EMPTY_ARRAY = 0,
  IMAGE_JPEG = "image/jpeg",
  JPG = "jpg",
  JPGE = "jpeg",
  LABOR_CERTIFICATION_OCR_CODE = "0030 CERTIFICACION LABORAL",
  MAXIMUM_FILE_SIZE = 1040000,
  NUMBER_ATTEMPTS = 3,
  NUMBER_ATTEMPTS_LOGIN_CUSTOMER_DESIGN = 1,
  NUMBER_MAX_BAR_PROGRESS = 100,
  PAYROLL_CHECKS_OCR_CODE = "desprendible",
  PDF = "pdf",
}
